import {
  LoginPage,
  TwoFactorPage,
  NewPasswordPage,
  OtpVerificationPage,
  ResetPasswordPage,
} from "@/modules/auth/pages";
import { AppPaths } from "@/shared/common/enums";
import { NotFound } from "@/shared/components";
import { AuthLayout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const authRoutes: RouteObject = {
  path: "/",
  element: <AuthLayout />,
  children: [
    { path: AppPaths.Login, element: <LoginPage /> },
    { path: AppPaths.Two_Factor, element: <TwoFactorPage /> },
    { path: AppPaths.New_Password, element: <NewPasswordPage /> },
    { path: AppPaths.Otp_Verification, element: <OtpVerificationPage /> },
    { path: AppPaths.Reset, element: <ResetPasswordPage /> },
    { path: "", element: <NotFound /> },
  ],
};
